































































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteButton from '../components/VoteButtonNew.vue';
import { isWeiXin } from '@/common/ts/common';
import { getList } from '../api';
import { Icon, List, Lazyload, Dialog, Toast, Popup, PullRefresh } from 'vant';
Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast)
  .use(Popup)
  .use(Icon);
@Component({
  components: {
    SearchBar,
    VoteButton,
    [PullRefresh.name]: PullRefresh,
  },
})
export default class Home extends Vue {
  search = '';
  list: any[] = [];
  objCounty: any = {};
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  workType: any = this.$route.query.workType;
  placeholder: any = '请输入关键字';
  showPop: boolean = false;
  title: string = '';
  voteName: string = '2023project/q3/2023sdjhc';
  isLoading: boolean = true;

  onLoad() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/image/default/2023-09-25/5beadd06122151bed62fde38c29fbf6a.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2023大渡口十大江湖菜评选活动',
      url: location.href,
      subtitle: ``,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2023大渡口十大江湖菜评选活动',
        subtitle: ``,
        image: cover,
      });
    }
    getList(this.page, this.search).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onRefresh() {
    this.page = 1;
    this.list = [];
    this.show = false;
    this.onLoad();
    setTimeout(() => {
      this.show = true;
      this.isLoading = false;
    }, 500);
    // this.isLoading = true;
    // setTimeout(() => {
    //   this.isLoading = false;
    // }, 500);
    // window.location.reload;
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  userInputChange(text: string) {
    this.search = text;
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  goDetail(id: any, enable: any) {
    this.$router.push(`activityDetail?id=${id}`);
  }
  showPopup() {
    this.showPop = true;
  }
  votSuccess(data: any, index: any) {
    this.list[index].votes = data;
  }
}
